 import overrideIfMinBetNumberEnabled from './MinBetNumberRegistrator'

 overrideIfMinBetNumberEnabled(function () {

     (function (betSlipUtil) {
         if (!betSlipUtil) return;

         var _getAllBetsDepositValue = betSlipUtil.getAllBetsDepositValue;
         $.extend(betSlipUtil, {
             getAllBetsDepositValue: function (mode) {
                 _getAllBetsDepositValue(mode);
                 if (mode.AllBetsDeposit === 0)
                     return;

                 if (!mode.validateMinBetNumber())
                     mode.AllBetsDeposit = 0;
             }
         });
     })(window.BetSlipUtil);

 });